/**
 * ES overnight hedging (the SPX+ES multi-underlying machinery) is only meaningful for
 * SPX-family underlyings (CR-20260606-001). For any other underlying — e.g. an equity an
 * independent portfolio is created against — the ES toggle and underlying picker are hidden.
 */
export const ES_HEDGEABLE_UNDERLYINGS = ['SPX', 'SPY', 'XSP'];

export function isEsHedgeableUnderlying(underlying: string): boolean {
    if (!underlying) {
        return false;
    }
    return ES_HEDGEABLE_UNDERLYINGS.indexOf(underlying.toUpperCase()) >= 0;
}
